import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobAuditReport'
import Component from 'components/Reports/JobAuditReport'

export default createListViewContainer({ actions, selectors: selectors.jobAuditReport })(Component)
